import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
  header: {
    backgroundColor: '#FF1F5E',
    height: 180,
    padding: 30,
    paddingTop: 80,
  },
  component: {
    padding: 15,
    backgroundColor: theme.palette.primary.bg,
    borderRadius: 8,
    boxShadow: '0 2px 5px 0 rgba(0,0,0,0.34)',
  },
  title:{
    color: '#FFF',
    position: 'relative',
    top: -40,
  },
}))

export default styles
